import { render, staticRenderFns } from "./Bootstrap3Modal.vue?vue&type=template&id=53ce90c9&"
import script from "./Bootstrap3Modal.vue?vue&type=script&lang=js&"
export * from "./Bootstrap3Modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports